import {RecentFiltersSectionConfig, FilterDialogSectionId} from 'filters/features/FilterDialog/types';

import {openFilterDialog} from 'filters/features/FilterDialog/emitter';
import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {SecondaryActionButton} from 'modules/decisionsNext/components/DecisionsDialog';

export const RecentFiltersSecondaryAction = ({recentId}: Omit<RecentFiltersSectionConfig, 'footer'>) => {
  const {setFilter} = useEditedFilterContext();
  const {useStoredFilters} = useFilterActionsContext();
  const {recentFilters} = useStoredFilters();

  return (
    <SecondaryActionButton
      disabled={!recentId}
      onClick={() => {
        const filter = recentFilters?.find(f => f.id === recentId)?.filter;

        if (!filter) {
          throw new Error(`No filter found ${recentId}`);
        }

        setFilter(filter);
        openFilterDialog(FilterDialogSectionId.ActiveFilters);
      }}
    >
      Preview
    </SecondaryActionButton>
  );
};
